module.exports = __webpack_public_path__ + "img/ic_close_red.b28e5c67.svg";